import { UserIdentity } from '@/types'
import { client } from '@/services/beef'
import { LOCAL_STORAGE_REDIRECT_URI_KEY } from '@/constants'

/**
  Authenticate an Auth0 response against the auth-api
* */
export const authenticateAgainstAuthX = (
  code: string, 
  tenantCode: string, 
  userDeviceToken?: string, 
  iid?: string, 
  state?: string, 
  deviceId?: string, 
  temporaryMfaSetup?: boolean
): Promise<UserIdentity> => {

  const redirecturi = localStorage.getItem(LOCAL_STORAGE_REDIRECT_URI_KEY) || ''

  return client.authenticate({
    body: {
      code,
      tenantCode,
      redirectUri: `${window.location.protocol}//${window.location.host}/authenticate`,
      userDeviceToken,
      state,
      deviceId,
      temporaryMfaSetup,
    },
    ...(iid || redirecturi
      ? {
          headers: {
            ...(iid ? { ['x-sm-mobile-app-device-id']: iid } : {}),
            ...(redirecturi ? { redirecturi } : {}),
          },
        }
      : {}),
  })
}
